import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { startWith } from 'rxjs';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';

@Component({
  selector: 'delivery-date-component-editor',
  templateUrl: './delivery-date-component-editor.component.html',
  styleUrls: ['./delivery-date-component-editor.component.scss'],
  standalone: false,
})
export class DeliveryDateComponentEditorComponent implements OnInit {
  @Input() componentForm: UntypedFormGroup;

  optionsForm: UntypedFormGroup;
  initialDisplayMessage: string;
  isHideThresholdActive: boolean = false;

  readonly calculationMethodOptions: DropdownOption[] = [
    {
      label: 'Fastest delivery date',
      value: ShopPlugin.ProductPagePromise.DeliveryDateCalculationMethod.FASTEST,
    },
    {
      label: 'Cheapest delivery date',
      value: ShopPlugin.ProductPagePromise.DeliveryDateCalculationMethod.CHEAPEST,
    },
  ];

  readonly promiseFormat = ShopPlugin.ProductPagePromise.DeliveryDatePromiseFormat;

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.optionsForm = this.componentForm.get('options') as UntypedFormGroup;
    this.initialDisplayMessage = this.optionsForm.get('displayMessage')?.value ?? '';

    this.optionsForm
      .get('hideIfLongDelivery')
      ?.valueChanges.pipe(
        startWith(this.optionsForm.get('hideIfLongDelivery')?.value),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((checked: boolean) => {
        this.isHideThresholdActive = !!checked;
        this.syncHideThresholdEnabledState(checked);
      });
  }

  get currentCalculationMethod(): DropdownOption {
    const value = this.optionsForm?.get('calculationMethod')?.value;
    return this.calculationMethodOptions.find((option) => option.value === value) ?? this.calculationMethodOptions[0];
  }

  onDisplayMessageChange(html: string): void {
    this.optionsForm.get('displayMessage').setValue(html);
    this.optionsForm.markAsDirty();
  }

  private syncHideThresholdEnabledState(checked: boolean): void {
    const thresholdControl = this.optionsForm.get('hideIfLongDeliveryDaysThreshold');
    if (!thresholdControl) return;
    if (checked) {
      thresholdControl.enable({ emitEvent: false });
    } else {
      thresholdControl.disable({ emitEvent: false });
    }
  }
}
